module.exports = __webpack_public_path__ + "static/media/medManager_07.aacc508c.png";